// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2AQis","left":"styles_left__1IzNw"};